import { useParams } from "react-router-dom";
import { useGetTaskQuery } from "../../features/tasks/tasksApi";
import TaskForm from "../taskAddEdit/TaskForm";

export default function EditTask() {
  const { taskId } = useParams()
  const { data: task, isLoading, isError } = useGetTaskQuery(taskId)

  return (
    <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
      <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
        Edit Task for Your Team
      </h1>

      <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
        {isLoading ?
          <div>Loading...</div>
          :
          task && task?.id ?

            task?.status=='complete' ? 
              <div>This task cannot be edited because it has completed</div>
            :
            <TaskForm initialTask={task} />
            : <div>Task Not Found</div>
        }
      </div>
    </main>
  )
}